/* Нужна обертка с <router-view> для того,
  чтобы все остальные роуты приложения работали как children языкового роута.
  Языковый роут является родительским для всего приложения */
import MainLayout from './components/TheMainLayout.vue';
import EmptyScreen from './views/EmptyScreen.vue';
import {ROUTE_PATHS} from './const';

export default [{
  path: '/:lang([a-z]{2})?', // Два символа подряд символизируют язык, библиотека i18n сама проверяет есть ли такая локализация, если такой локализации нет, то оно делает редирект на 404
  component: MainLayout,
  children: [{
    path: 'surebet-calculator',
    name: 'SureBetCalculatorScreen',
    component: () => import(/* webpackChunkName: "surebet-calculator" */ './views/SureBetCalculatorScreen.vue'),
  }, {
    path: 'calculator',
    component: () => import(/* webpackChunkName: "scanner-page-alone-calculator" */ './views/ScannerPageAloneCalculatorScreen.vue'),
    children: [{
      path: '',
      name: 'SureBetAloneCalculator',
      component: () => import(/* webpackChunkName: "scanner-page-alone-calculator" */ './components/arbs/calculator/ScannerPageCalculatorWrapperComponent.vue'),
    }],
  }, {
    path: 'valuebet_calculator',
    component: () => import(/* webpackChunkName: "scanner-page-alone-calculator" */ './views/ScannerPageAloneCalculatorScreen.vue'),
    children: [{
      path: '',
      name: 'ValueBetAloneCalculator',
      component: () => import(/* webpackChunkName: "scanner-page-alone-calculator" */ './components/valuebets/calculator/ValueBetsPageCalculatorWrapperComponent.vue'),
    }],
  }, {
    path: 'valuebet_calculator_v2',
    component: () => import(/* webpackChunkName: "scanner-page-alone-calculator" */ './views/ScannerPageAloneCalculatorScreen.vue'),
    children: [{
      path: '',
      name: 'ValueBetAloneCalculatorV2',
      component: () => import(/* webpackChunkName: "scanner-page-alone-calculator" */ './components/valuebets-v2/calculator/ValueBetsPageCalculatorWrapperComponent.vue'),
    }],
  }, {
    path: 'arbs',
    component: () => import(/* webpackChunkName: "arbs-screen" */ './views/ArbsScreen.vue'),
    children: [{
      path: '',
      name: 'SureBetsPreMatch',
      meta: {
        isLive: false,
        pageName: 'arbs', // Нужно для индикации страницы в сайдбаре
        pricesRoutePath: ROUTE_PATHS.arbsPrices, // Адрес на страницу прайсингов  для конкретного раздела для навигации в хедере,кнопка "Pricing"
      },
      component: () => import(/* webpackChunkName: "arbs-screen" */ './components/arbs/ArbsLayoutComponent.vue'),
    }, {
      path: 'live',
      name: 'SureBetsLive',
      meta: {
        isLive: true,
        pageName: 'arbs',
        pricesRoutePath: ROUTE_PATHS.arbsPrices, // Адрес на страницу прайсингов  для конкретного раздела для навигации в хедере,кнопка "Pricing"
      },
      component: () => import(/* webpackChunkName: "arbs-screen" */ './components/arbs/ArbsLayoutComponent.vue'),
    }],
  },
  {
    path: 'valuebets',
    component: () => import(/* webpackChunkName: "value-bets-screen" */ './views/ValueBetsScreen.vue'),
    children: [{
      path: '',
      meta: {
        isLive: false,
        pageName: 'valuebets', // Нужно для индикации страницы в сайдбаре
        pricesRoutePath: ROUTE_PATHS.valueBetsPrices, // Адрес на страницу прайсингов  для конкретного раздела для навигации в хедере,кнопка "Pricing"
      },
      name: 'ValueBetsPreMatch',
      component: () => import(/* webpackChunkName: "value-bets-screen" */ './components/valuebets/ValueBetLayoutComponent.vue'),
    }, {
      path: 'live',
      name: 'ValueBetsLive',
      meta: {
        isLive: true,
        pageName: 'valuebets', // Нужно для индикации страницы в сайдбаре
        pricesRoutePath: ROUTE_PATHS.valueBetsPrices,
      },
      component: () => import(/* webpackChunkName: "value-bets-screen" */ './components/valuebets/ValueBetLayoutComponent.vue'),
    }],
  },
  {
    path: 'v2/valuebets',
    component: () => import(/* webpackChunkName: "value-bets-screen-v2" */ './views/ValueBetsScreenV2.vue'),
    children: [{
      path: '',
      meta: {
        isLive: false,
        pageName: 'valuebets',
        pricesRoutePath: ROUTE_PATHS.valueBetsPrices,
      },
      name: 'ValueBetsPreMatchV2',
      component: () => import(/* webpackChunkName: "value-bets-layout-v2" */ './components/valuebets-v2/ValueBetLayoutComponent.vue'),
    }, {
      path: 'live',
      name: 'ValueBetsLiveV2',
      meta: {
        isLive: true,
        pageName: 'valuebets',
        pricesRoutePath: ROUTE_PATHS.valueBetsPrices,
      },
      component: () => import(/* webpackChunkName: "value-bets-layout-v2" */ './components/valuebets-v2/ValueBetLayoutComponent.vue'),
    }],
  }, {
    path: 'api',
    component: () => import(/* webpackChunkName: "api-screen" */ './views/ApiPageArbsScreen.vue'),
    children: [{
      path: '',
      name: 'SureBetsApiPreMatch',
      meta: {
        isLive: false,
        isValueBetsApiPage: false, // Нужно чтобы понимать какую модаль фильтров открывать при онбоардинге валуев или вилок
        pageName: 'arbsApi', // Нужно для индикации страницы в сайдбаре
        pricesRoutePath: ROUTE_PATHS.apiPrices, // Адрес на страницу прайсингов  для конкретного раздела для навигации в хедере,кнопка "Pricing"
      },
      component: () => import(/* webpackChunkName: "api-screen" */ './components/api/ArbsApiLayoutComponent.vue'),
    }, {
      path: 'live',
      name: 'SureBetsApiLive',
      meta: {
        isLive: true,
        isValueBetsApiPage: false, // Нужно чтобы понимать какую модаль фильтров открывать при онбоардинге валуев или вилок
        pageName: 'arbsApi',
        pricesRoutePath: ROUTE_PATHS.apiPrices, // Адрес на страницу прайсингов  для конкретного раздела для навигации в хедере,кнопка "Pricing"
      },
      component: () => import(/* webpackChunkName: "api-screen" */ './components/api/ArbsApiLayoutComponent.vue'),
    }],
  }, {
    path: 'api_valuebets',
    component: () => import(/* webpackChunkName: "api-screen" */ './views/ApiPageValueBetScreen.vue'),
    children: [{
      path: '',
      name: 'ValueBetsApiPreMatch',
      meta: {
        isLive: false,
        isValueBetsApiPage: true, // Нужно чтобы понимать какую модаль фильтров открывать при онбоардинге валуев или вилок
        pageName: 'ValueBetsApi', // Нужно для индикации страницы в сайдбаре
        pricesRoutePath: ROUTE_PATHS.apiPrices, // Адрес на страницу прайсингов  для конкретного раздела для навигации в хедере,кнопка "Pricing"
      },
      component: () => import(/* webpackChunkName: "api-screen" */ './components/api/ValueBetApiLayoutComponent.vue'),
    }, {
      path: 'live',
      name: 'ValueBetsApiLive',
      meta: {
        isLive: true,
        isValueBetsApiPage: true, // Нужно чтобы понимать какую модаль фильтров открывать при онбоардинге валуев или вилок
        pageName: 'ValueBetsApi',
        pricesRoutePath: ROUTE_PATHS.apiPrices, // Адрес на страницу прайсингов  для конкретного раздела для навигации в хедере,кнопка "Pricing"
      },
      component: () => import(/* webpackChunkName: "api-screen" */ './components/api/ValueBetApiLayoutComponent.vue'),
    }],
  }, {
    path: 'v2/api_valuebets',
    component: () => import(/* webpackChunkName: "api-screen-v2" */ './views/ApiPageValueBetScreenV2.vue'),
    children: [{
      path: '',
      name: 'ValueBetsApiPreMatchV2',
      meta: {
        isLive: false,
        isValueBetsApiPage: true,
        pageName: 'ValueBetsApi',
        pricesRoutePath: ROUTE_PATHS.apiPrices,
      },
      component: () => import(/* webpackChunkName: "api-screen-v2" */ './components/api/ValueBetApiV2LayoutComponent.vue'),
    }, {
      path: 'live',
      name: 'ValueBetsApiLiveV2',
      meta: {
        isLive: true,
        isValueBetsApiPage: true,
        pageName: 'ValueBetsApi',
        pricesRoutePath: ROUTE_PATHS.apiPrices,
      },
      component: () => import(/* webpackChunkName: "api-screen-v2" */ './components/api/ValueBetApiV2LayoutComponent.vue'),
    }],
  }, {
    path: ':pathMatch(.*)*', // Все пути которые не прописаны на фронтовом роутере будут обрабатываться сервером
    name: 'EmptyPage',
    component: EmptyScreen, // Покажем екран с лоадером
    meta: {
      isEmptyPage: true,
    },
    beforeEnter(to, from, next) {
      next(); // Меняем адрес на новый путь
      location.reload(); // Перегрузим страницу, чтобы путь начал обрабатыватсья сервером
    },
  }],
}];
